import React from 'react';
import { Flex } from 'rebass';
import { SearchInput } from '../../../../components/Form';
import { isBrowser } from 'react-device-detect';
import { FilterBarProps } from '../../../../components/FilterBar/FilterBar';
import { rebassProps } from '../../../../theme/theme';
import ResetFiltersButton from '../../../../components/FilterBar/ResetFiltersButton';
import { getStringSearchPlaceholder } from '../../../../helpers/search';
import { searchFields } from './WaterHazards';
import {
  HazardLevel,
  HazardLevelPicker,
} from '../../../../components/WaterHazard/HazardLevelPicker';

export type WaterHazardFilters = {
  hazardLevel?: HazardLevel;
  stringSearch?: string | undefined;
};

export const defaultFilters: WaterHazardFilters = {
  stringSearch: undefined,
};

type FilterBarAdminWaterHazardsProps = FilterBarProps<WaterHazardFilters>;

const FilterBarWaterHazards: React.FC<FilterBarAdminWaterHazardsProps> = (
  props
) => {
  const { filters, setFilters, selectedId } = props;

  const onChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setFilters((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  return (
    <Flex variant="filterBar.container" {...(props as rebassProps)}>
      <Flex variant="filterBar.left">
        <SearchInput
          placeholder={getStringSearchPlaceholder(searchFields)}
          width={300}
          name="stringSearch"
          value={filters.stringSearch === undefined ? '' : filters.stringSearch}
          onChange={onChange}
        />
        <HazardLevelPicker
          isClearable
          onChange={(value) => {
            setFilters({
              ...filters,
              hazardLevel: value,
            });
          }}
          value={filters.hazardLevel}
        />
      </Flex>
      <Flex variant="filterBar.right">
        <ResetFiltersButton setFilters={setFilters} />
      </Flex>
    </Flex>
  );
};

export default FilterBarWaterHazards;
